import { Button } from '@cian/ui-kit';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';
import * as React from 'react';

import { TCallbackOpener } from 'shared/types/callbackPopup';

interface ICallBackButtonProps {
  size: TButtonSize;
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
  placeType?: TCallbackOpener;
  loading?: boolean;
  callbackButtonText?: string;
  beforeIcon?: React.JSX.Element;
  fullWidth?: boolean;
  theme?: TButtonTheme;
}

export const CallbackButton: React.FC<ICallBackButtonProps> = ({
  size,
  onClick,
  placeType,
  loading,
  callbackButtonText,
  beforeIcon,
  fullWidth = true,
  theme,
}) => {
  return (
    <Button
      data-testid={`callback-button-${placeType}`}
      onClick={onClick}
      theme={theme}
      size={size}
      fullWidth={fullWidth}
      loading={loading}
      beforeIcon={beforeIcon}
    >
      {callbackButtonText}
    </Button>
  );
};
